import { JSX } from 'react';

import { ToastStore } from '../../stores/Toast/ToastStore';
import { IToastOptions } from '../../stores/Toast/ToastStore.types';

export function showToast(content: JSX.Element | string, options?: Partial<IToastOptions>): void {
  ToastStore.show(content, options);
}
